module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d7938d9353ddf22816aca9a861a6ac74.gif";